/// <amd-module name="SuiteCommerce.GiftCertificate.OptionTiles.TilesContainer.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.OptionTiles.TilesContainer.View", ["require", "exports", "underscore", "Backbone", "SuiteCommerce.GiftCertificate.Common.Utils", "SuiteCommerce.GiftCertificate.OptionTiles.Configuration", "SuiteCommerce.GiftCertificate.OptionTiles.Tile.CollectionView", "option_tiles_container.tpl", "SuiteCommerce.GiftCertificate.Instrumentation"], function (require, exports, _, Backbone_1, Utils_1, OptionTiles_Configuration_1, OptionTiles_Tile_CollectionView_1, template, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TilesContainerView = void 0;
    var TilesContainerView = /** @class */ (function (_super) {
        __extends(TilesContainerView, _super);
        function TilesContainerView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = template;
            if (_this.model.isGiftCertificateItem()) {
                _this.collection.fetch().done(function () {
                    _this.collection.sort();
                    _this.render();
                });
            }
            _this.events = {
                'click [data-action="open-gift-certificate"]': 'openGiftCertificate',
            };
            return _this;
        }
        Object.defineProperty(TilesContainerView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    GiftCertificateTiles: function () {
                        return new OptionTiles_Tile_CollectionView_1.TileCollectionView({
                            collection: _this.collection,
                            childViewOptions: {
                                currentGiftCertificate: _this.model,
                            },
                        });
                    },
                };
            },
            enumerable: false,
            configurable: true
        });
        TilesContainerView.prototype.openGiftCertificate = function (event) {
            var itemUrl = this.$el.find(event.target).data('itemurl')
                || this.$el.find(event.target).parent('button').data('itemurl');
            if (itemUrl) {
                itemUrl = this.getItemUrlWithCurrentUrlParams(itemUrl);
                Backbone_1.history.navigate(itemUrl, { trigger: true });
            }
            this.logClickOnTile();
        };
        TilesContainerView.prototype.logClickOnTile = function () {
            var clickOnTailLog = Instrumentation_1.default.getLog('clickOnTailLog');
            clickOnTailLog.setParameters({
                activity: 'Click on Option Tile button',
            });
            clickOnTailLog.submit();
        };
        TilesContainerView.prototype.getItemUrlWithCurrentUrlParams = function (itemUrl) {
            var giftCertificateFormFieldsSelected = _.pick(Utils_1.Utils.parseUrlOptions(location.href), 'from', 'to', 'to-email', 'message');
            return Utils_1.Utils.addParamsToUrl(itemUrl, giftCertificateFormFieldsSelected);
        };
        TilesContainerView.prototype.getContext = function () {
            return {
                giftCertificateOptionsLabel: OptionTiles_Configuration_1.OptionTilesConfiguration.itemOptionsLabel,
            };
        };
        return TilesContainerView;
    }(Backbone_1.View));
    exports.TilesContainerView = TilesContainerView;
});
